import { render, staticRenderFns } from "./FormPageShell.vue?vue&type=template&id=d76ed940&scoped=true"
import script from "./FormPageShell.vue?vue&type=script&lang=js"
export * from "./FormPageShell.vue?vue&type=script&lang=js"
import style0 from "./FormPageShell.vue?vue&type=style&index=0&id=d76ed940&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d76ed940",
  null
  
)

export default component.exports